import Swal from "sweetalert2";
import { information } from "../information";

export const login = async (username, password) => {
  let myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  const {

    adminurl_thai_789bet,
    api_thai_789bet,
    api_local,
    site_local,
  } = information;
  let ENDPOINT = api_local;
  let SITE = site_local;
  const host = window.location.hostname;
  if (adminurl_thai_789bet.includes(host)) {
    ENDPOINT = api_thai_789bet;
    SITE = "thai_789bet";
  }
  let raw = JSON.stringify({
    username: username,
    password: password,
  });

  let requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };

  return await fetch(ENDPOINT + "/account/login?site=" + SITE, requestOptions)
    .then((response) => response.json())
    .then((result) => {
      console.log("aaaaaa", result);
      localStorage.setItem("endpoint-redeem", ENDPOINT);
      localStorage.setItem("site-redeem", SITE);
      return result;
    })
    .catch((error) => {
      console.log("error", error);
      if (error.status_code === 404) {
        return Swal.fire({
          icon: "error",
          title: "Đăng nhập không thành công",
          text: error.mess,
        });
      }
      return Swal.fire({ icon: "error", text: "Thao tác lỗi" });
    });
};

export const verify_otp = async (otp_token, username) => {
  let myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  let raw = JSON.stringify({
    otp_token: otp_token,
    username: username,
  });

  let requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };

  return await fetch(localStorage.getItem("endpoint-redeem") + "/account/verify2FA?site=" + localStorage.getItem("site-redeem"), requestOptions)
    .then((response) => response.json())
    .then((result) => {
      return result;
    })
    .catch((error) => {
      console.log("error", error);
      return Swal.fire({ icon: "error", text: "Thao tác lỗi" });
    });
};
